import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FormlyFormOptions, FormlyModule } from '@ngx-formly/core';
import { map, takeWhile } from 'rxjs';
import { markFormGroupsTouched } from '../../../utils/reactive-form/reactive-form.util';
import { AddressSelectFormModel } from './address-select-form.model';
import { AddressSelectFormService } from './address-select-form.service';

@Component({
  selector: 'gk-address-select-form',
  templateUrl: './address-select-form.component.html',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormlyModule,
    FormlyBootstrapModule,
  ],
})
export class AddressSelectFormComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @Input() form: FormGroup;
  @Input() options: FormlyFormOptions;
  @Input() submitted: boolean;
  formModel: AddressSelectFormModel;
  formlyFormConfig = this.addressSelectFormService.getFormConfig();
  @Output() formValueChanges = new EventEmitter<AddressSelectFormModel>();
  private isAlive = true;

  constructor(private addressSelectFormService: AddressSelectFormService) {}

  ngOnInit(): void {
    this.initializeFormModel();
  }

  ngAfterViewInit(): void {
    if (this.submitted) {
      markFormGroupsTouched(this.form);
    }
  }

  initializeFormModel(): void {
    this.addressSelectFormService
      .getFormModel()
      .pipe(takeWhile(() => this.isAlive))
      .subscribe((formModel) => {
        if (formModel) {
          this.formModel = formModel;
        }
      });
  }

  setAddressSelectFormGroupValue(
    addressSelectFormGroup: AddressSelectFormModel,
  ): void {
    this.formlyFormConfig
      .pipe(
        takeWhile(() => this.isAlive),
        map((config) => config.fields),
      )
      .subscribe((fields) => {
        this.addressSelectFormService.setAddressByIds(
          addressSelectFormGroup,
          this.form,
          fields,
        );
      });
  }

  ngOnDestroy(): void {
    this.isAlive = false;
  }
}
